import { SERVER_URL } from './constants';

// Fired whenever the server says the viewer session is missing or expired; useAccessControl
// listens and drops back to the access-code screen.
export const UNAUTHORIZED_EVENT = 'bodycam:unauthorized';

// Bumped every time access is granted. A request that started under an older generation
// went out without the current session cookie, so its 401 says nothing about this session.
let accessGeneration = 0;

export function markAccessGranted() {
  accessGeneration += 1;
}

// startedGeneration: the generation a request started under; omit it for signals that are
// always about the current session (e.g. the socket's 'auth-required').
export function notifyUnauthorized(startedGeneration) {
  if (startedGeneration !== undefined && startedGeneration !== accessGeneration) return;
  window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
}

// 401s from these are the login flow itself, not an expired session
const AUTH_PATHS = new Set(['/api/verify-access', '/api/session', '/api/logout']);

let interceptorInstalled = false;

// Catches a 401 from every backend API call in one place, including fetches made outside
// the hooks, instead of each call site checking for it.
export function installUnauthorizedInterceptor() {
  if (interceptorInstalled || typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  interceptorInstalled = true;

  const serverOrigin = new URL(SERVER_URL, window.location.href).origin;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const startedGeneration = accessGeneration;
    const response = await originalFetch(input, init);
    if (response.status === 401) {
      try {
        const url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
        if (url.origin === serverOrigin && url.pathname.startsWith('/api/') && !AUTH_PATHS.has(url.pathname)) {
          notifyUnauthorized(startedGeneration);
        }
      } catch {}
    }
    return response;
  };
}
